import { EntityService } from 'src/service/EntityService';

export class CustomerService extends EntityService {

  static entity = 'iam-party/customers';

  static find(term: string): Promise<any> {
    return this.axios.get(`${this.entity}/find`, { params: { term } }).then(res => res.data);
  }

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/detail`).then(res => res.data);
  }

  static create(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/create`, data).then(res => res.data);
  }

  static uploadExcel(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/import-excel`, data).then(res => res.data);
  }

}